// src/styles/theme.js
//
// Design tokens for ExamNova. Dark mode is the production theme.
// Light mode tokens exist but a full light-mode pass is post-launch.
//
// ADDING TOKENS: Add to BOTH light and dark. Keep semantic names
// (e.g. `shell` not `#0a0f1a`). Use raw hex in the values; the
// styled-components ThemeProvider injects them via `theme.xxx`.

export const light = {
  isDark: false,
  // ── Backgrounds ──────────────────────────────────────────────────
  background: "linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%)",
  bodyBg: "#f8fafc",
  shell: "#f1f5f9",         // App shell / outermost bg
  surface: "#ffffff",       // Cards, modals, panels
  panel: "#f8fafc",         // Slightly off-white inset panels
  // ── Text ────────────────────────────────────────────────────────
  text: "#1e293b",
  textSecondary: "#64748b",
  textMuted: "#94a3b8",
  // ── Borders ─────────────────────────────────────────────────────
  border: "#e2e8f0",
  cardBorder: "rgba(255, 255, 255, 0.3)",
  divider: "#e2e8f0",
  // ── Cards ───────────────────────────────────────────────────────
  cardBg: "rgba(255, 255, 255, 0.7)",
  // ── Brand / Interactive ─────────────────────────────────────────
  primary: "#6366f1",
  primaryHover: "#4f46e5",
  secondary: "#10b981",
  hover: "rgba(99, 102, 241, 0.1)",
  // ── Semantic status ─────────────────────────────────────────────
  successBg: "#d1fae5",
  successText: "#10b981",
  successBorder: "#6ee7b7",
  errorBg: "#fee2e2",
  errorText: "#ef4444",
  errorBorder: "#fca5a5",
  warningBg: "#fffbeb",
  warningText: "#d97706",
  warningBorder: "#fcd34d",
  infoBg: "rgba(59, 130, 246, 0.08)",
  infoText: "#3b82f6",
  infoBorder: "rgba(59, 130, 246, 0.3)",
  // ── Quiz option states ───────────────────────────────────────────
  optionCorrectBg: "#d1fae5",
  optionCorrectBorder: "#6ee7b7",
  optionCorrectText: "#10b981",
  optionWrongBg: "#fee2e2",
  optionWrongBorder: "#fca5a5",
  optionWrongText: "#ef4444",
  optionSelectedBg: "rgba(59, 130, 246, 0.1)",
  optionSelectedBorder: "rgba(59, 130, 246, 0.4)",
  optionSelectedText: "#3b82f6",
  // ── Misc ────────────────────────────────────────────────────────
  glassShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.07)",
  backdropFilter: "blur(12px)",
};

export const dark = {
  isDark: true,
  // ── Backgrounds ──────────────────────────────────────────────────
  background: "linear-gradient(135deg, #0f172a 0%, #1e1e2f 100%)",
  bodyBg: "#0f172a",
  shell: "#0a0f1a",         // Deepest dark (sidebar, top chrome)
  surface: "#1e293b",       // Cards, modals, panels
  panel: "#0f172a",         // Slightly recessed panels
  // ── Text ────────────────────────────────────────────────────────
  text: "#f8fafc",
  textSecondary: "#94a3b8",
  textMuted: "#64748b",
  // ── Borders ─────────────────────────────────────────────────────
  border: "#334155",
  cardBorder: "rgba(255, 255, 255, 0.08)",
  divider: "#1e293b",
  // ── Cards ───────────────────────────────────────────────────────
  cardBg: "rgba(30, 41, 59, 0.7)",
  // ── Brand / Interactive ─────────────────────────────────────────
  primary: "#818cf8",        // Lighter indigo for dark mode contrast
  primaryHover: "#6366f1",
  secondary: "#34d399",
  hover: "rgba(129, 140, 248, 0.15)",
  // ── Semantic status ─────────────────────────────────────────────
  successBg: "rgba(16, 185, 129, 0.15)",
  successText: "#34d399",
  successBorder: "rgba(52, 211, 153, 0.4)",
  errorBg: "rgba(239, 68, 68, 0.15)",
  errorText: "#fca5a5",
  errorBorder: "rgba(239, 68, 68, 0.4)",
  warningBg: "rgba(217, 119, 6, 0.15)",
  warningText: "#fbbf24",
  warningBorder: "rgba(251, 191, 36, 0.4)",
  infoBg: "rgba(59, 130, 246, 0.1)",
  infoText: "#60a5fa",
  infoBorder: "rgba(59, 130, 246, 0.3)",
  // ── Quiz option states ───────────────────────────────────────────
  optionCorrectBg: "rgba(16, 185, 129, 0.12)",
  optionCorrectBorder: "rgba(52, 211, 153, 0.5)",
  optionCorrectText: "#10b981",
  optionWrongBg: "rgba(239, 68, 68, 0.1)",
  optionWrongBorder: "rgba(239, 68, 68, 0.45)",
  optionWrongText: "#ef4444",
  optionSelectedBg: "rgba(59, 130, 246, 0.12)",
  optionSelectedBorder: "rgba(59, 130, 246, 0.45)",
  optionSelectedText: "#3b82f6",
  // ── Misc ────────────────────────────────────────────────────────
  glassShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.3)",
  backdropFilter: "blur(12px)",
};
